  <template>
      <span :class="['status-tag', statusClass]" style="--bs-bg-opacity: .5;">{{ text }}</span>
    </template>
    
    <script>
    export default {
      name: "StatusTag",
      props: {
        status: {
          type: String,
          required: true,
          validator: function(value) {
            return ['APPROVED','DISAPPROVED','PENDING','INITIATED'].includes(value);
          }
        }
      },
      computed: {
        text() {
          switch (this.status) {
            case "APPROVED": return this.$t("views.dashboard.status.approved");
            case "DISAPPROVED": return this.$t("views.dashboard.status.disapproved");
            default: return this.$t("views.dashboard.status.pending");
          }
        },
        statusClass() {
          let bootstrapClass = null;
          switch (this.status) {
            case "APPROVED": 
              bootstrapClass = "success"; 
              break;
            case "DISAPPROVED": 
              bootstrapClass = "danger";  
              break;
            default: 
              bootstrapClass = "warning"; 
              break;
          }
          
          return `border border-${bootstrapClass} text-${bootstrapClass}`;
        }
      }
    };
    </script>
    
    <style scoped>
    .status-tag {
      display: inline-block;
      padding: 0.0em 0.5em;
      font-size: 0.7em;
      font-weight: 500;
      border-radius: 1em; /* Deixa as bordas arredondadas */
      text-align: center;
      width: fit-content;
      margin-top: 0.1rem;
      margin-bottom: 0.1rem;
    }
    </style>
    